import { Observable } from 'rxjs/Rx';
import { ConfirmDialog } from '../confirm-dialog/confirm-dialog.component';
import { AlertDialog } from '../alert-dialog/alert-dialog.component';
import { AutocompleteDialogComponent } from '../autocomplete-dialog/autocomplete-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

@Injectable()
export class DialogsService {

    constructor(private dialog: MatDialog) { }

    public confirm(message: string, title='Confirmation'): Observable<boolean> {

        let dialogRef = this.dialog.open(ConfirmDialog, {
        	width: '400px',
        	data: {title: title, message: message}
        });

        return dialogRef.afterClosed();
    }

    public autocomplete(title: string, selectList: string[]): Observable<number> {
    	let dialogRef = this.dialog.open(AutocompleteDialogComponent, {
    		width: '400px',
    		height: '300px',
    		data: {title: title, options: selectList}
    	});

    	return dialogRef.afterClosed();
    }

    public alert(message: string): Observable<boolean> {
        let dialogRef = this.dialog.open(AlertDialog, {
            width: '250px',
            data: {title: 'Confirmation', message: message}
        });

        return dialogRef.afterClosed();
    }
}